import React, { Component } from 'react';
import { get, post } from 'axios';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ProposalServices from './ProposalServices';
import ProposalLineitem from './ProposalLineitem';
import Notifications, {notify} from 'react-notify-toast';
import { inject, observer } from 'mobx-react';
import Modal from 'react-bootstrap4-modal';
import ModalBookingServices from './ModalBookingServices';


@inject('userStore')
@observer
class InqiuryProposal extends Component {
    constructor(props){
        super(props);
        this.state = {
            lineitem_list:[],
            bus_srv_list:[],
            proposalLineitemList:[],
            service_list:[],
            service_total:0,
            lineitem_total:0,
            event_total:0,
            bk_temp_proposal_hash_id:'',
            emailSent:null,
            modalVisible:false
        }
        this.addLineitem = this.addLineitem.bind(this);
        this.backHandler = this.backHandler.bind(this);
        this.addLineitem = this.addLineitem.bind(this);
        this.deleteLineitem = this.deleteLineitem.bind(this);
        this.getProposal = this.getProposal.bind(this);
        this.sendProposal = this.sendProposal.bind(this);
        this.updateService = this.updateService.bind(this);
    }

    componentDidMount(){
        this.getProposal();
        post('/v2/get/lineitems', {bk_temp_hash_id: this.props.inquiry.hash_id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            this.setState({
                lineitem_list: res.data.lineitem_list,
                bus_srv_list: res.data.bus_srv_list
            })
        }).catch((error) => {
            console.log(error);
            return error;
        });
    }

    modalBackgroundClicked = () => {
        this.setState({
            modalVisible:!this.state.modalVisible
        });
    }

    updateService(service, index){
        post('/v2/post/service_update', {hash_id:this.state.bk_temp_proposal_hash_id, bus_srv_id: service.bus_srv_id, price:service.price, index:index, quantity:service.quantity},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors == 0){
                this.getProposal();
                notify.show(res.data.message, "success", 3000);
            } else {
                notify.show('Error occurred: '+ res.data.message, "error", 3000);
            }
        }).catch((error) => {
            console.log(error);
            return error;
        });
    }

    sendProposal(){
        post('/v2/send/proposal', {bk_temp_hash_id: this.props.inquiry.hash_id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors == 0){
                if (res.data.proposal){
                    console.log(this.props.inquiry.current_stage_id);
                    this.setState({
                        emailSent:res.data.proposal.email_sent
                    }, () => {this.props.inquiry.current_stage_id = res.data.current_stage_id})
                    console.log(this.props.inquiry.current_stage_id);
                }
                notify.show('Email sent', "success", 3000);
            } else {
                notify.show('Error occurred: '+ res.data.message, "error", 3000);
            }
        }).catch((error) => {
            console.log(error);
            return error;
        });
    }

    getProposal(){
        post('/v2/get/proposal', {bk_temp_hash_id: this.props.inquiry.hash_id}, {
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.proposal){
                this.setState({
                    service_list:res.data.proposal.service_list,
                    service_total:res.data.proposal.service_total,
                    lineitem_total:res.data.proposal.lineitem_total,
                    proposalLineitemList:res.data.proposal.lineitem_list,
                    event_total:res.data.proposal.event_total,
                    bk_temp_proposal_hash_id:res.data.proposal.hash_id,
                    emailSent:res.data.proposal.email_sent
                })
            }
        }).catch((error) => {
            console.log(error);
            return error;
        });
    }

    addService = (service) => {
      if (service.quantity === 0){
        service.quantity = 1;
      }
      post('/v2/save/inquiry_service', {hash_id: this.props.inquiry.hash_id, service:service}, {
        auth: {username: this.props.userStore.token}
      }).then((res) => {
        if (res.data.errors === 0){
          this.setState({
            service_list:res.data.proposal.service_list,
            service_total:res.data.proposal.service_total,
            lineitem_total:res.data.proposal.lineitem_total,
            proposalLineitemList:res.data.proposal.lineitem_list,
            event_total:res.data.proposal.event_total,
            bk_temp_proposal_hash_id:res.data.proposal.hash_id,
            emailSent:res.data.proposal.email_sent
          })
          alert('Added Service');
        } else {
          notify.show('Error', 3000);
          alert(res.data.message);
        }
      }).catch((error) => {
        notify.show('Error', 3000);
        return error;
      });
    }

    addLineitem(lineitem){
        post('/v2/save/lineitem', {hash_id: this.state.bk_temp_proposal_hash_id, typeof:'proposal', description:lineitem.description, bus_lineitem_id:lineitem.id, price_override:lineitem.default_amount, quantity:lineitem.quantity},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                // reload with the new lineitem
                if (res.data.proposal){
                    this.setState({
                        service_list:res.data.proposal.service_list,
                        service_total:res.data.proposal.service_total,
                        lineitem_total:res.data.proposal.lineitem_total,
                        proposalLineitemList:res.data.proposal.lineitem_list,
                        event_total:res.data.proposal.event_total,
                        bk_temp_proposal_hash_id:res.data.proposal.hash_id
                    })
                }
                notify.show('Added Line Item: ' +  lineitem.name, "success", 3000);
            } else {
                notify.show('Error occurred: '+ res.data.message, "error", 3000);
            }
        }).catch((error) => {
            notify.show('Error', 3000);
            return error;
        });
    }

    deleteLineitem(lineitem){
        post('/v2/delete/lineitem', {hash_id: this.state.bk_temp_proposal_hash_id, bus_lineitem_id:lineitem.bus_lineitem_id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                // reload with the new lineitem
                if (res.data.proposal){
                    this.setState({
                        service_list:res.data.proposal.service_list,
                        service_total:res.data.proposal.service_total,
                        lineitem_total:res.data.proposal.lineitem_total,
                        proposalLineitemList:res.data.proposal.lineitem_list,
                        event_total:res.data.proposal.event_total,
                        bk_temp_proposal_hash_id:res.data.proposal.hash_id
                    })
                }
                notify.show('Removed Line Item: ' + lineitem.name, "success", 3000);
            } else {
                notify.show('Error occurred: '+ res.data.message, "error", 3000);
            }
        }).catch((error) => {
            notify.show('Error occurred: '+ error, "error", 3000);
            console.log(error);
            return error;
        });
    }


    backHandler(){
        this.props.handler();
    }

    render() {
        if (!this.props.inquiry) return <div className="alert alert-danger">No Inquiry Loaded</div>;
        return (
            <React.Fragment>
            <Notifications />
            <Modal visible={this.state.modalVisible} onClickBackdrop={() => this.modalBackgroundClicked()} dialogClassName="modal-lg w-900px">
                <div className="modal-header">
                    <h4 className="modal-title">Add Services</h4>
                    <button type="button" className="close" onClick={() => this.modalBackgroundClicked(null)} aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div className="modal-body h-600px">
                <PerfectScrollbar>
                  <ModalBookingServices booking={this.props.inquiry} service_list={this.state.bus_srv_list} addServiceHandler={this.addService}/>
                </PerfectScrollbar>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => this.modalBackgroundClicked(null)}>
                      Close
                    </button>
                </div>
            </Modal>
            <div className="main-content pt-20">
                <header className="header header-transparent">
                    <div className="header-info mb-0">
                        <div className="left">
                            <h2 className="header-title">Event Proposal <small className="subtitle">{this.props.inquiry.full_name}<br/>{this.props.inquiry.date} @ {this.props.inquiry.ready_time}</small></h2>
                            {this.state.emailSent ? <span className="badge badge-success">Proposal sent to <strong>{this.state.emailSent.email}</strong> on <strong>{this.state.emailSent.last_modified}</strong></span> : <span className="badge badge-danger">Proposal has not been sent</span>}
                        </div>
                        <div className="right gap-items-2">
                            <a className="btn btn-secondary btn-square btn-round" onClick={this.backHandler}><i className="fa fa-remove"></i></a>
                        </div>
                    </div>
                </header>
                <div className="card form-type-combine">
                    <ProposalServices service_list={this.state.service_list} lineitem_list={this.state.proposalLineitemList} service_total={this.state.service_total} lineitem_total={this.state.lineitem_total} event_total={this.state.event_total} deleteHandler={this.deleteLineitem} for_booking={null} updateHandler={this.updateService}/>
                    <div className="card-body">
                      <div className="row mb-20">
                        <div className="col-sm-12">
                          <div className="btn-group pull-right">
                            <button className="btn btn-success" onClick={()=>this.setState({modalVisible:!this.state.modalVisible})}><i className="fa fa-plus"></i> Add Services</button>
                            <button className="btn btn-primary" onClick={this.sendProposal}>Send</button>
                          </div>
                        </div>
                      </div>
                        <div className="row">
                        {this.state.lineitem_list.map((lineitem, index) =>
                            <div className="col-sm-6 col-md-4" key={index}>
                                <ProposalLineitem lineitem={lineitem} handler={this.addLineitem}/>
                            </div>
                        )}
                        </div>
                    </div>
                    <footer className="card-footer">
                        <div className="pull-left">
                            {this.state.emailSent ? <span className="badge badge-success">Proposal sent to <strong>{this.state.emailSent.email}</strong> on <strong>{this.state.emailSent.last_modified}</strong></span> : <span className="badge badge-danger">Proposal has not been sent</span>}
                        </div>
                        <div className="btn-group pull-right">
                            <button className="btn btn-secondary" onClick={this.backHandler}>Back</button>
                            <button className="btn btn-primary" onClick={this.sendProposal}>Send</button>
                        </div>
                    </footer>
                </div>
            </div>
            </React.Fragment>
        )
  }
}

export default InqiuryProposal;



// WEBPACK FOOTER //
// ./src/components/business/InquiryProposal.js